/**
 * 运行时快速捕捉模式枚举。
 * 说明：与工具栏 quick-snap 子菜单的 mode 一一对应，确保类型安全。
 */
export enum QuickSnapMode {
    /** 点捕捉（端点与孤立点）。 */
    Point = 'quick-snap-point',
    /** 中心点捕捉。 */
    Center = 'quick-snap-center',
    /** 中点捕捉。 */
    Midpoint = 'quick-snap-mid',
    /** 象限点捕捉。 */
    Quadrant = 'quick-snap-quadrant',
    /** 交叉点捕捉。 */
    Intersection = 'quick-snap-intersection',
    /** 最近端捕捉。 */
    Nearest = 'quick-snap-nearest',
    /** 相切捕捉。 */
    Tangent = 'quick-snap-tangent',
    /** 水平/垂直点捕捉。 */
    HorizontalVertical = 'quick-snap-hv',
    /** 网格捕捉。 */
    Grid = 'quick-snap-grid',
}